module.exports = __webpack_public_path__ + "static/img/14areaA_7.a28b8c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/14areaA_7.png
// module id = 1011
// module chunks = 1